export default "__VITE_ASSET__hlp4BFSg__"